import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/dastan/Work/www/oopt-front/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module link/utils
 */

/**
 * Helper class that ties together all {@link module:link/link~LinkDecoratorAutomaticDefinition} and provides
 * a {@link module:engine/conversion/downcasthelpers~DowncastHelpers#attributeToElement downcast dispatcher} for them.
 */
var AutomaticDecorators = /*#__PURE__*/function () {
  function AutomaticDecorators() {
    _classCallCheck(this, AutomaticDecorators);

    /**
     * Stores the definition of {@link module:link/link~LinkDecoratorAutomaticDefinition automatic decorators}.
     * This data is used as a source for a downcast dispatcher to create a proper conversion to output data.
     *
     * @private
     * @type {Set}
     */
    this._definitions = new Set();
  }
  /**
   * Gives information about the number of decorators stored in the {@link module:link/utils~AutomaticDecorators} instance.
   *
   * @readonly
   * @protected
   * @type {Number}
   */


  _createClass(AutomaticDecorators, [{
    key: "add",

    /**
     * Adds automatic decorator objects or an array with them to be used during downcasting.
     *
     * @param {module:link/link~LinkDecoratorAutomaticDefinition|Array.<module:link/link~LinkDecoratorAutomaticDefinition>} item
     * A configuration object of automatic rules for decorating links. It might also be an array of such objects.
     */
    value: function add(item) {
      var _this = this;

      if (Array.isArray(item)) {
        item.forEach(function (item) {
          return _this._definitions.add(item);
        });
      } else {
        this._definitions.add(item);
      }
    }
    /**
     * Provides the conversion helper used in the {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add} method.
     *
     * @returns {Function} A dispatcher function used as conversion helper
     * in {@link module:engine/conversion/downcasthelpers~DowncastHelpers#add}.
     */

  }, {
    key: "getDispatcher",
    value: function getDispatcher() {
      var _this2 = this;

      return function (dispatcher) {
        dispatcher.on('attribute:linkHref', function (evt, data, conversionApi) {
          // There is only test as this behavior decorates links and
          // it is run before dispatcher which actually consumes this node.
          // This allows on writing own dispatcher with highest priority,
          // which blocks both native converter and this additional decoration.
          if (!conversionApi.consumable.test(data.item, 'attribute:linkHref')) {
            return;
          }

          var viewWriter = conversionApi.writer;
          var viewSelection = viewWriter.document.selection;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = _this2._definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var item = _step.value;
              var viewElement = viewWriter.createAttributeElement('a', item.attributes, {
                priority: 5
              });
              viewWriter.setCustomProperty('link', true, viewElement);

              if (item.callback(data.attributeNewValue)) {
                if (data.item.is('selection')) {
                  viewWriter.wrap(viewSelection.getFirstRange(), viewElement);
                } else {
                  viewWriter.wrap(conversionApi.mapper.toViewRange(data.range), viewElement);
                }
              } else {
                viewWriter.unwrap(conversionApi.mapper.toViewRange(data.range), viewElement);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }, {
          priority: 'high'
        });
      };
    }
  }, {
    key: "length",
    get: function get() {
      return this._definitions.size;
    }
  }]);

  return AutomaticDecorators;
}();

export { AutomaticDecorators as default };